export default "__VITE_ASSET__347225de__"